import { Box, Drawer } from "@mui/material";
import { useDrawer } from "./context/DrawerContext";
import { memo } from "react";

const DrawerContainer: React.FC<{ width: string }> = ({ width }) => {
    const { isOpen, content, closeDrawer } = useDrawer();

    return (
        <Drawer
            anchor="right"
            open={isOpen}
            onClose={closeDrawer}
            slotProps={{
                paper: {
                    style: {
                        width,
                        overflow: 'hidden',
                    },
                },
            }}>
            <Box>
                <Box>{content}</Box>
            </Box>
        </Drawer>
    );
};

export default memo(DrawerContainer);